<template>
  <div class="custom-selection-edit">
    <custom-selection-edit-header :name="name" />
    <div class="content">
      <custom-selection-edit-column
        :type="'sport'"
        :name="'product.sports' | translate"
        :items="sports"
        @load="loadTournaments"
      />
      <custom-selection-edit-column
        :type="'tournament'"
        :name="'product.tournaments' | translate"
        :items="tournaments"
        :selections="tournamentBetTemplates"
        @load="loadBets"
      />
      <custom-selection-edit-column
        :type="'bet'"
        :name="'general.bets' | translate"
        :items="bets"
        @load="loadMatches"
      />
      <custom-selection-edit-column
        :type="'match'"
        :name="'general.matches' | translate"
        :items="matches"
      />
    </div>
    <div class="custom-selection-edit-footer">
      <button-standard @click="saveSelection">
        {{ 'general.save' | translate }}
      </button-standard>
    </div>
  </div>
</template>

<script>
import CustomSelectionEditHeader from './CustomSelectionEditHeader.vue';
import CustomSelectionEditColumn from './CustomSelectionEditColumn.vue';
import ButtonStandard from '@/components/controls/button/ButtonStandard.vue';

export default {
  name: 'CustomSelectionEdit',
  components: {
    CustomSelectionEditHeader,
    CustomSelectionEditColumn,
    ButtonStandard,
  },
  data() {
    const params = this.$route.params || {};
    const query = this.$route.query || {};
    const hasOffer = Object.prototype.hasOwnProperty.call(query, 'offer') || false;
    const hasStatistics = Object.prototype.hasOwnProperty.call(query, 'statistics') || false;
    const isActive = Object.prototype.hasOwnProperty.call(query, 'active') || false;

    return {
      id: params.id,
      selectionType: +params.selectionType,
      selectionConfig: +params.selectionConfig,
      active: isActive,
      name: query.name || '',
      date: {
        start: +params.startDate,
        end: +params.endDate,
      },
      offer: hasOffer,
      statistics: hasStatistics,
    };
  },
  mounted() {
    this.loadSports();
    this.$store.dispatch('prematch/customSelection/updateSelectionOptions', {
      offer: this.offer,
      statistics: this.statistics,
    });
  },
  computed: {
    sports() {
      return this.$store.state.prematch.customSelection.sports;
    },
    tournaments() {
      return this.$store.getters['prematch/customSelection/tournaments'];
    },
    tournamentBetTemplates() {
      return this.$store.getters['prematch/customSelection/tournamentBetTemplates'];
    },
    bets() {
      return this.$store.getters['prematch/customSelection/bets'];
    },
    matches() {
      return this.$store.getters['prematch/customSelection/matches'];
    },
  },
  methods: {
    getParams() {
      return {
        id_selection: this.id,
        selection_type: this.selectionType,
        startDate: this.date.start,
        endDate: this.date.end,
        id_bet: this.$store.state.prematch.customSelection.selectedId.bet,
        id_sport: this.$store.state.prematch.customSelection.selectedId.sport,
        id_tournament: this.$store.state.prematch.customSelection.selectedId.tournament,
      };
    },
    loadSports() {
      const params = this.getParams();
      this.$store.dispatch('prematch/customSelection/load', {
        type: 'sports',
        params,
      });
    },
    loadTournaments(idSport) {
      this.$store.state.prematch.customSelection.search.tournament = '';
      this.$store.state.prematch.customSelection.search.bet = '';
      this.$store.state.prematch.customSelection.search.match = '';
      this.$store.dispatch('prematch/customSelection/setCopiedBets', []);
      this.$store.dispatch('prematch/customSelection/setSelectedId', {
        sport: idSport,
        tournament: '',
        bet: '',
      });
      if (this.tournaments) return;

      const params = this.getParams();
      this.$store.dispatch('prematch/customSelection/load', {
        type: 'tournaments',
        params,
      });
      this.$store.dispatch('prematch/customSelection/getTournamentBetTemplates', params);
    },
    loadBets(idTournament) {
      this.$store.state.prematch.customSelection.search.bet = '';
      this.$store.state.prematch.customSelection.search.match = '';
      this.$store.dispatch('prematch/customSelection/setSelectedId', {
        tournament: idTournament,
        bet: '',
      });
      if (this.bets) return;

      const params = this.getParams();
      this.$store.dispatch('prematch/customSelection/load', {
        type: 'bets',
        params,
      });
    },
    loadMatches(idBet) {
      this.$store.state.prematch.customSelection.search.match = '';
      this.$store.dispatch('prematch/customSelection/setSelectedId', { bet: idBet });
      if (this.matches) return;

      const params = this.getParams();
      this.$store.dispatch('prematch/customSelection/load', {
        type: 'matches',
        params,
      });
    },
    saveSelection() {
      const params = {
        active: this.active,
        content: {
          offer: this.$store.state.prematch.customSelection.isSelected.offer,
          statistics: this.$store.state.prematch.customSelection.isSelected.statistics,
        },
        idSelection: this.id,
        selectionConfig: this.selectionConfig,
        selectionName: this.name,
        startDate: this.date.start,
        endDate: this.date.end,
      };
      this.$store.dispatch('prematch/customSelection/saveSelection', params);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/style/variables';

.custom-selection-edit {
  color: $color-text-primary;
}

.content {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-evenly;
  min-height: 500px;
  max-height: 85vh;
  border-top: 1px solid #d3dadd;
  border-bottom: 1px solid #d3dadd;
}

.custom-selection-edit-footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 55px;
  padding: 0 20px;
}

.content > .content-column:last-child {
  /deep/ .column-item-icon {
    display: none;
  }
}
</style>
